export const GALLERIES = {
  drawings: {
    images: [
      {
        src: "./gallery/drawings/PXL_20251223_170546815-preview.jpg", full: "./gallery/drawings/PXL_20251223_170546815.jpg",
        height: 4759,
        width: 6156,
      },
      {
        src: "./gallery/drawings/PXL_20260127_183225622-preview.jpg", full: "./gallery/drawings/PXL_20260127_183225622.jpg",
        height: 3533,
        width: 2587,
      },
      {
        src: "./gallery/drawings/PXL_20260210_183333989-preview.jpg", full: "./gallery/drawings/PXL_20260210_183333989.jpg",
        height: 2203,
        width: 2184,
      },
      {
        src: "./gallery/drawings/PXL_20260310_164417890-preview.png", full: "./gallery/drawings/PXL_20260310_164417890.png",
        height: 2864,
        width: 4021,
      },
      {
        src: "./gallery/drawings/PXL_20260310_183037602-preview.jpg", full: "./gallery/drawings/PXL_20260310_183037602.jpg",
        height: 2733,
        width: 3833,
      },
      {
        src: "./gallery/drawings/PXL_20260331_170348267-preview.jpg", full: "./gallery/drawings/PXL_20260331_170348267.jpg",
        height: 2788,
        width: 3921,
      },
      {
        src: "./gallery/drawings/PXL_20260408_175900262-preview.jpg", full: "./gallery/drawings/PXL_20260408_175900262.jpg",
        height: 2593,
        width: 3789,
      },
      {
        src: "./gallery/drawings/PXL_20260414_171829071-preview.jpg", full: "./gallery/drawings/PXL_20260414_171829071.jpg",
        height: 2860,
        width: 3934,
      },
      {
        src: "./gallery/drawings/PXL_20260414_171843616-preview.jpg", full: "./gallery/drawings/PXL_20260414_171843616.jpg",
        height: 2707,
        width: 3906,
      },
      {
        src: "./gallery/drawings/PXL_20260512_172233750-preview.png", full: "./gallery/drawings/PXL_20260512_172233750.png",
        height: 3025,
        width: 2105,
      },
      {
        src: "./gallery/drawings/PXL_20260512_172307316-preview.jpg", full: "./gallery/drawings/PXL_20260512_172307316.jpg",
        height: 2768,
        width: 3982,
      },
      {
        src: "./gallery/drawings/PXL_20260603_104824309-preview.jpg", full: "./gallery/drawings/PXL_20260603_104824309.jpg",
        height: 2800,
        width: 3922,
      },
      {
        src: "./gallery/drawings/PXL_20260603_104831215-preview.jpg", full: "./gallery/drawings/PXL_20260603_104831215.jpg",
        height: 2741,
        width: 3885,
      },
      {
        src: "./gallery/drawings/PXL_20260623_172732581-preview.jpg", full: "./gallery/drawings/PXL_20260623_172732581.jpg",
        height: 3976,
        width: 2764,
      },
      {
        src: "./gallery/drawings/PXL_20260623_172744019-preview.jpg", full: "./gallery/drawings/PXL_20260623_172744019.jpg",
        height: 3891,
        width: 2739,
      },
      {
        src: "./gallery/drawings/PXL_20260728_170721819-preview.jpg", full: "./gallery/drawings/PXL_20260728_170721819.jpg",
        height: 3687,
        width: 2577,
      },
      {
        src: "./gallery/drawings/PXL_20260811_163641815-preview.jpg", full: "./gallery/drawings/PXL_20260811_163641815.jpg",
        height: 3996,
        width: 2331,
      },
      {
        src: "./gallery/drawings/PXL_20250422_153527563-preview.jpg", full: "./gallery/drawings/PXL_20250422_153527563.jpg",
        height: 825,
        width: 931,
      },
      {
        src: "./gallery/drawings/PXL_20250702_175915655-preview.jpg", full: "./gallery/drawings/PXL_20250702_175915655.jpg",
        height: 772,
        width: 1067,
      },
      {
        src: "./gallery/drawings/PXL_20250723_173553918-preview.jpg", full: "./gallery/drawings/PXL_20250723_173553918.jpg",
        height: 2742,
        width: 3175,
      },
      {
        src: "./gallery/drawings/PXL_20250729_172050353-preview.jpg", full: "./gallery/drawings/PXL_20250729_172050353.jpg",
        height: 3841,
        width: 2568,
      },
      {
        src: "./gallery/drawings/PXL_20250909_184542274-preview.jpg", full: "./gallery/drawings/PXL_20250909_184542274.jpg",
        height: 2163,
        width: 3695,
      },
      {
        src: "./gallery/drawings/PXL_20251111_183409068-preview.jpg", full: "./gallery/drawings/PXL_20251111_183409068.jpg",
        height: 344,
        width: 489,
      },
      {
        src: "./gallery/drawings/PXL_20251111_183435458-preview.jpg", full: "./gallery/drawings/PXL_20251111_183435458.jpg",
        height: 2586,
        width: 3601,
      },
      { src: "./gallery/drawings/U5f9Cic-preview.png", full: "./gallery/drawings/U5f9Cic.png", height: 89, width: 123 },
      { src: "./gallery/drawings/eR5KiqF-preview.png", full: "./gallery/drawings/eR5KiqF.png", height: 67, width: 96 },
      { src: "./gallery/drawings/Hsx0aer-preview.jpeg", full: "./gallery/drawings/Hsx0aer.jpeg", height: 97, width: 77 },
      { src: "./gallery/drawings/JieA7rf-preview.png", full: "./gallery/drawings/JieA7rf.png", height: 67, width: 82 },
      { src: "./gallery/drawings/k8uLOMc-preview.jpeg", full: "./gallery/drawings/k8uLOMc.jpeg", height: 40, width: 59 },
      { src: "./gallery/drawings/EaRqWDr-preview.jpeg", full: "./gallery/drawings/EaRqWDr.jpeg", height: 29, width: 21 },
      { src: "./gallery/drawings/lIPw0OM-preview.jpg", full: "./gallery/drawings/lIPw0OM.jpg", height: 95, width: 67 },
      { src: "./gallery/drawings/r49DGF9-preview.jpg", full: "./gallery/drawings/r49DGF9.jpg", height: 41, width: 57 },
      { src: "./gallery/drawings/wb9kEBJ-preview.png", full: "./gallery/drawings/wb9kEBJ.png", height: 85, width: 93 },
      { src: "./gallery/drawings/DKnwcN8-preview.png", full: "./gallery/drawings/DKnwcN8.png", height: 64, width: 51 },
      { src: "./gallery/drawings/3B4MxEl-preview.jpg", full: "./gallery/drawings/3B4MxEl.jpg", height: 96, width: 137 },
      { src: "./gallery/drawings/sD18ZKr-preview.png", full: "./gallery/drawings/sD18ZKr.png", height: 17, width: 21 },
      { src: "./gallery/drawings/POTD1u2-preview.png", full: "./gallery/drawings/POTD1u2.png", height: 37, width: 52 },
      { src: "./gallery/drawings/QgUa6mJ-preview.jpg", full: "./gallery/drawings/QgUa6mJ.jpg", height: 4, width: 3 },
      { src: "./gallery/drawings/TOp7r2F-preview.png", full: "./gallery/drawings/TOp7r2F.png", height: 46, width: 37 },
      { src: "./gallery/drawings/uzCcIbC-preview.png", full: "./gallery/drawings/uzCcIbC.png", height: 71, width: 97 },
      { src: "./gallery/drawings/4KrHpmZ-preview.jpg", full: "./gallery/drawings/4KrHpmZ.jpg", height: 97, width: 69 },
      { src: "./gallery/drawings/DdLfbgF-preview.jpg", full: "./gallery/drawings/DdLfbgF.jpg", height: 3, width: 4 },
      { src: "./gallery/drawings/FrMYm80-preview.jpg", full: "./gallery/drawings/FrMYm80.jpg", height: 95, width: 67 },
      { src: "./gallery/drawings/BTlJRAb-preview.jpg", full: "./gallery/drawings/BTlJRAb.jpg", height: 65, width: 97 },
      { src: "./gallery/drawings/o6TpfCD-preview.png", full: "./gallery/drawings/o6TpfCD.png", height: 12, width: 17 },
      { src: "./gallery/drawings/26u8Lnj-preview.png", full: "./gallery/drawings/26u8Lnj.png", height: 41, width: 88 },
      { src: "./gallery/drawings/MZyYjGU-preview.jpg", full: "./gallery/drawings/MZyYjGU.jpg", height: 5, width: 7 },
      { src: "./gallery/drawings/gWyLkPj-preview.jpg", full: "./gallery/drawings/gWyLkPj.jpg", height: 8, width: 11 },
      { src: "./gallery/drawings/sm5lg6y-preview.jpg", full: "./gallery/drawings/sm5lg6y.jpg", height: 3, width: 4 },
      { src: "./gallery/drawings/LSUSRPW-preview.jpg", full: "./gallery/drawings/LSUSRPW.jpg", height: 61, width: 94 },
      { src: "./gallery/drawings/hxSQBV2-preview.jpg", full: "./gallery/drawings/hxSQBV2.jpg", height: 52, width: 125 },
      { src: "./gallery/drawings/2bo6iXx-preview.jpg", full: "./gallery/drawings/2bo6iXx.jpg", height: 4, width: 3 },
      {
        src: "./gallery/drawings/2W2IsPn-preview.jpg", full: "./gallery/drawings/2W2IsPn.jpg",
        height: 79,
        width: 84,
      },
      {
        src: "./gallery/drawings/cdaAwuL-preview.png", full: "./gallery/drawings/cdaAwuL.png",
        height: 79,
        width: 104,
      },
      {
        src: "./gallery/drawings/6W5Zz9w-preview.jpg", full: "./gallery/drawings/6W5Zz9w.jpg",
        height: 67,
        width: 52,
      },
      {
        src: "./gallery/drawings/jPSzuCA-preview.jpg", full: "./gallery/drawings/jPSzuCA.jpg",
        height: 73,
        width: 54,
      },
      {
        src: "./gallery/drawings/kIqHqDy-preview.jpg", full: "./gallery/drawings/kIqHqDy.jpg",
        height: 70,
        width: 113,
      },
      {
        src: "./gallery/drawings/iOhvfnr-preview.gif", full: "./gallery/drawings/iOhvfnr.gif",
        height: 95,
        width: 169,
      },
      {
        src: "./gallery/drawings/gnh3Vmf-preview.gif", full: "./gallery/drawings/gnh3Vmf.gif",
        height: 95,
        width: 169,
      },
      {
        src: "./gallery/drawings/zbN9H8a-preview.png", full: "./gallery/drawings/zbN9H8a.png",
        height: 27,
        width: 31,
      },
      {
        src: "./gallery/drawings/PcANck0-preview.png", full: "./gallery/drawings/PcANck0.png",
        height: 59,
        width: 73,
      },
      {
        src: "./gallery/drawings/18jn39O-preview.png", full: "./gallery/drawings/18jn39O.png",
        height: 29,
        width: 41,
      },
      {
        src: "./gallery/drawings/EADSNuG-preview.png", full: "./gallery/drawings/EADSNuG.png",
        height: 50,
        width: 37,
      },
      {
        src: "./gallery/drawings/9h5abMz-preview.jpg", full: "./gallery/drawings/9h5abMz.jpg",
        height: 4,
        width: 3,
      },
      { src: "./gallery/drawings/M3ilRoC-preview.png", full: "./gallery/drawings/M3ilRoC.png", height: 79, width: 225 },
      { src: "./gallery/drawings/dvSaUsB-preview.png", full: "./gallery/drawings/dvSaUsB.png", height: 91, width: 53 },
      { src: "./gallery/drawings/OmeCgmo-preview.png", full: "./gallery/drawings/OmeCgmo.png", height: 71, width: 69 },
      { src: "./gallery/drawings/wZ3Jhzn-preview.png", full: "./gallery/drawings/wZ3Jhzn.png", height: 7, width: 5 },
      {
        src: "./gallery/drawings/QymU1kv-preview.jpg", full: "./gallery/drawings/QymU1kv.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/drawings/WOWdF5a-preview.jpg", full: "./gallery/drawings/WOWdF5a.jpg",
        height: 3,
        width: 4,
      },
      // {
      //   src: "https://i.imgur.com/VcgrZfI.jpg",
      //   height: 4,
      //   width: 3,
      // },
      {
        src: "./gallery/drawings/p6q75Ci-preview.jpg", full: "./gallery/drawings/p6q75Ci.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/drawings/5YLESqI-preview.jpg", full: "./gallery/drawings/5YLESqI.jpg",
        height: 58,
        width: 45,
      },
      {
        src: "./gallery/drawings/NIf6FBr-preview.png", full: "./gallery/drawings/NIf6FBr.png",
        height: 19,
        width: 27,
      },
      {
        src: "./gallery/drawings/9xMeyka-preview.png", full: "./gallery/drawings/9xMeyka.png",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/drawings/MLGA2nW-preview.png", full: "./gallery/drawings/MLGA2nW.png",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/drawings/shp8QoC-preview.png", full: "./gallery/drawings/shp8QoC.png",
        height: 77,
        width: 61,
      },
      {
        src: "./gallery/drawings/IsITVWo-preview.png", full: "./gallery/drawings/IsITVWo.png",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/drawings/qWcSFyJ-preview.jpg", full: "./gallery/drawings/qWcSFyJ.jpg",
        height: 70,
        width: 53,
      },
      {
        src: "./gallery/drawings/cfoCMdf-preview.jpg", full: "./gallery/drawings/cfoCMdf.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/drawings/1FElTGc-preview.jpg", full: "./gallery/drawings/1FElTGc.jpg",
        height: 84,
        width: 115,
      },
      {
        src: "./gallery/drawings/hIiyo1D-preview.jpg", full: "./gallery/drawings/hIiyo1D.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/drawings/ooKeW41-preview.jpg", full: "./gallery/drawings/ooKeW41.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/drawings/DIe6VDJ-preview.jpg", full: "./gallery/drawings/DIe6VDJ.jpg",
        height: 33,
        width: 32,
      },
      {
        src: "./gallery/drawings/JuOMNev-preview.jpg", full: "./gallery/drawings/JuOMNev.jpg",
        height: 100,
        width: 99,
      },
      {
        src: "./gallery/drawings/6zml2GL-preview.jpg", full: "./gallery/drawings/6zml2GL.jpg",
        height: 75,
        width: 122,
      },
      {
        width: 126,
        height: 89,
        src: "./gallery/drawings/M5P8i6C-preview.jpg", full: "./gallery/drawings/M5P8i6C.jpg",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings/bzMabf6-preview.jpg", full: "./gallery/drawings/bzMabf6.jpg",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings/hZA2K3t-preview.jpg", full: "./gallery/drawings/hZA2K3t.jpg",
      },
      {
        width: 63,
        height: 71,
        src: "./gallery/drawings/PUvwiKM-preview.jpg", full: "./gallery/drawings/PUvwiKM.jpg",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings/yvQGcxT-preview.jpg", full: "./gallery/drawings/yvQGcxT.jpg",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings/bgjdwzx-preview.jpg", full: "./gallery/drawings/bgjdwzx.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/drawings/3sHxzow-preview.png", full: "./gallery/drawings/3sHxzow.png",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/drawings/MKUcKe0-preview.jpg", full: "./gallery/drawings/MKUcKe0.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/drawings/dLFRUnv-preview.jpg", full: "./gallery/drawings/dLFRUnv.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/drawings/eup2xSk-preview.jpg", full: "./gallery/drawings/eup2xSk.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/drawings/5tocNvt-preview.jpg", full: "./gallery/drawings/5tocNvt.jpg",
      },
      {
        width: 49,
        height: 64,
        src: "./gallery/drawings/9CPheDY-preview.jpg", full: "./gallery/drawings/9CPheDY.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/drawings/gIjwvVg-preview.png", full: "./gallery/drawings/gIjwvVg.png",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings/1NnJokx-preview.png", full: "./gallery/drawings/1NnJokx.png",
      },
      { src: "./gallery/drawings/GvW92ZH-preview.png", full: "./gallery/drawings/GvW92ZH.png", height: 95, width: 73 },
      { src: "./gallery/drawings/TH4Keax-preview.png", full: "./gallery/drawings/TH4Keax.png", height: 7, width: 5 },
      { src: "./gallery/drawings/LuwCA1n-preview.png", full: "./gallery/drawings/LuwCA1n.png", height: 7, width: 5 },
      { src: "./gallery/drawings/5BhWBo8-preview.png", full: "./gallery/drawings/5BhWBo8.png", height: 7, width: 5 },
      { src: "./gallery/drawings/62G6RIR-preview.png", full: "./gallery/drawings/62G6RIR.png", height: 62, width: 45 },
      { src: "./gallery/drawings/SmO0OJ8-preview.png", full: "./gallery/drawings/SmO0OJ8.png", height: 27, width: 40 },
      {
        width: 7,
        height: 5,
        src: "./gallery/drawings/vm7FUhP-preview.jpg", full: "./gallery/drawings/vm7FUhP.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/drawings/26ih5iy-preview.jpg", full: "./gallery/drawings/26ih5iy.jpg",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings/3quCeuR-preview.jpg", full: "./gallery/drawings/3quCeuR.jpg",
      },
    ],
    rowHeight: 400,
    preview: "./gallery/drawings/preview_08lQQn7.png",
    title: "Paintings and drawings done since 2017",
  },
  estrogen: {
    images: [
      {
        src: "./gallery/estrogen/tcMf783-preview.jpg", full: "./gallery/estrogen/tcMf783.jpg",
        height: 65,
        width: 97,
      },
      {
        src: "./gallery/estrogen/yQOeWuj-preview.png", full: "./gallery/estrogen/yQOeWuj.png",
        height: 12,
        width: 17,
      },
      {
        src: "./gallery/estrogen/VpMKHRh-preview.jpg", full: "./gallery/estrogen/VpMKHRh.jpg",
        height: 77,
        width: 109,
      },
      {
        src: "./gallery/estrogen/est-black-1-preview.png", full: "./gallery/estrogen/est-black-1.png",
        height: 15,
        width: 18,
      },
      {
        src: "./gallery/estrogen/est-black-2-preview.png", full: "./gallery/estrogen/est-black-2.png",
        height: 15,
        width: 18,
      },
      {
        src: "./gallery/estrogen/est-white-1-preview.png", full: "./gallery/estrogen/est-white-1.png",
        height: 15,
        width: 18,
      },
      {
        src: "./gallery/estrogen/est-white-2-preview.png", full: "./gallery/estrogen/est-white-2.png",
        height: 15,
        width: 18,
      },
      {
        src: "./gallery/estrogen/HpkXep8-preview.png", full: "./gallery/estrogen/HpkXep8.png",
        height: 79,
        width: 225,
      },
    ],
    rowHeight: 400,
    preview: "./gallery/estrogen/preview_taCQhBm.png",
    title: "Estrogen Exhibit",
    description: "Inspired by the Estrogen (Estradiol) molecule C18H24O2",
  },
  wall: {
    images: [
      {
        src: "./gallery/wall/4monki6-preview.jpg", full: "./gallery/wall/4monki6.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/jvpcrmH-preview.jpg", full: "./gallery/wall/jvpcrmH.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/q62e97t-preview.jpg", full: "./gallery/wall/q62e97t.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/T9wJACV-preview.jpg", full: "./gallery/wall/T9wJACV.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/wall/yskBECi-preview.jpg", full: "./gallery/wall/yskBECi.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/wall/2LuqT1h-preview.jpg", full: "./gallery/wall/2LuqT1h.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/wall/lfEeBx2-preview.jpg", full: "./gallery/wall/lfEeBx2.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/wall/waMPMXE-preview.jpg", full: "./gallery/wall/waMPMXE.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/wall/gHYwhoT-preview.jpg", full: "./gallery/wall/gHYwhoT.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/SKPHvJx-preview.jpg", full: "./gallery/wall/SKPHvJx.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/xgGwxwg-preview.jpg", full: "./gallery/wall/xgGwxwg.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/IfjHqmb-preview.jpg", full: "./gallery/wall/IfjHqmb.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/ALUybGz-preview.jpg", full: "./gallery/wall/ALUybGz.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/wall/WfnkCrz-preview.jpg", full: "./gallery/wall/WfnkCrz.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/kQV41pv-preview.jpg", full: "./gallery/wall/kQV41pv.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/qNAtdGX-preview.jpg", full: "./gallery/wall/qNAtdGX.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/wall/2HTZ3SA-preview.jpg", full: "./gallery/wall/2HTZ3SA.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/wall/mqxm9c2-preview.jpg", full: "./gallery/wall/mqxm9c2.jpg",
        height: 3,
        width: 4,
      },
    ],
    rowHeight: 400,
    preview: "./gallery/wall/preview_87fIDXr.png",
    title: "Steps of drawing the office wall",
  },
  king: {
    images: [
      {
        src: "./gallery/king/653Bg7H-preview.jpg", full: "./gallery/king/653Bg7H.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/IxnfOiI-preview.jpg", full: "./gallery/king/IxnfOiI.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/qYcXlJ3-preview.jpg", full: "./gallery/king/qYcXlJ3.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/king/TCLAX94-preview.jpg", full: "./gallery/king/TCLAX94.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/IZ90Euh-preview.jpg", full: "./gallery/king/IZ90Euh.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/94fg1uG-preview.jpg", full: "./gallery/king/94fg1uG.jpg",
        height: 77,
        width: 71,
      },
      {
        src: "./gallery/king/JdJqYL1-preview.jpg", full: "./gallery/king/JdJqYL1.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/p3fZcP5-preview.jpg", full: "./gallery/king/p3fZcP5.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/t0z2THz-preview.jpg", full: "./gallery/king/t0z2THz.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/i1aPVXK-preview.jpg", full: "./gallery/king/i1aPVXK.jpg",
        height: 3,
        width: 4,
      },
      {
        src: "./gallery/king/EO7jWBA-preview.jpg", full: "./gallery/king/EO7jWBA.jpg",
        height: 87,
        width: 85,
      },
      {
        src: "./gallery/king/Uu7qMvJ-preview.jpg", full: "./gallery/king/Uu7qMvJ.jpg",
        height: 70,
        width: 53,
      },
      {
        src: "./gallery/king/MBBmh6u-preview.jpg", full: "./gallery/king/MBBmh6u.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/BglccBg-preview.jpg", full: "./gallery/king/BglccBg.jpg",
        height: 4,
        width: 3,
      },
      {
        src: "./gallery/king/8IVl5JE-preview.jpg", full: "./gallery/king/8IVl5JE.jpg",
        height: 57,
        width: 43,
      },
      {
        src: "./gallery/king/su5MLU2-preview.png", full: "./gallery/king/su5MLU2.png",
        height: 50,
        width: 37,
      },
    ],
    rowHeight: 1000,
    preview: "./gallery/king/preview_LXeYPHa.png",
    title: "Steps of drawing The King in Red",
  },
  branding101: {
    images: [
      {
        src: "./gallery/branding101/pjmh4cB-preview.png", full: "./gallery/branding101/pjmh4cB.png",
        height: 100,
        width: 79,
      },
      {
        src: "./gallery/branding101/cM4lDMt-preview.png", full: "./gallery/branding101/cM4lDMt.png",
        height: 97,
        width: 374,
      },
      {
        src: "./gallery/branding101/Ht7j72D-preview.png", full: "./gallery/branding101/Ht7j72D.png",
        height: 77,
        width: 170,
      },
      {
        src: "./gallery/branding101/Q5sVAm7-preview.png", full: "./gallery/branding101/Q5sVAm7.png",
        height: 70,
        width: 99,
      },
      {
        src: "./gallery/branding101/tj3535E-preview.png", full: "./gallery/branding101/tj3535E.png",
        height: 70,
        width: 99,
      },
      {
        src: "./gallery/branding101/aQotmln-preview.png", full: "./gallery/branding101/aQotmln.png",
        height: 18,
        width: 13,
      },
      {
        src: "./gallery/branding101/8C2B8oT-preview.png", full: "./gallery/branding101/8C2B8oT.png",
        height: 89,
        width: 155,
      },
      {
        src: "./gallery/branding101/pOBxOm8-preview.png", full: "./gallery/branding101/pOBxOm8.png",
        height: 55,
        width: 79,
      },
    ],
    rowHeight: 300,
    preview: "./gallery/branding101/preview_gykvAcX.png",
    description: "Works done in the course Intro to Branding",
    links: ["https://bis.reallyliri.com"],
    title: "Intro to Branding",
  },
  design101: {
    images: [
      {
        src: "./gallery/design101/R6u9aYV-preview.jpg", full: "./gallery/design101/R6u9aYV.jpg",
        height: 93,
        width: 203,
      },
      {
        src: "./gallery/design101/V5rcsaW-preview.jpg", full: "./gallery/design101/V5rcsaW.jpg",
        height: 99,
        width: 70,
      },
      {
        src: "./gallery/design101/XwqKF94-preview.png", full: "./gallery/design101/XwqKF94.png",
        height: 7,
        width: 5,
      },
      {
        src: "./gallery/design101/NhgCmde-preview.jpg", full: "./gallery/design101/NhgCmde.jpg",
        height: 7,
        width: 5,
      },
      {
        src: "./gallery/design101/8DlIFg6-preview.png", full: "./gallery/design101/8DlIFg6.png",
        height: 7,
        width: 5,
      },
      {
        src: "./gallery/design101/y4LogOe-preview.png", full: "./gallery/design101/y4LogOe.png",
        height: 7,
        width: 5,
      },
    ],
    rowHeight: 500,
    preview: "./gallery/design101/preview_B5mTN4b.png",
    description: "Works done in the course Intro to Design",
    links: [
      "https://42.reallyliri.com",
      "https://broken-fingaz.reallyliri.com",
    ],
    title: "Intro to Design",
  },
  illustrator: {
    images: [
      {
        width: 41,
        height: 29,
        src: "./gallery/illustrator/LYWlVfN-preview.png", full: "./gallery/illustrator/LYWlVfN.png",
      },
      {
        width: 95,
        height: 68,
        src: "./gallery/illustrator/9jgDa9q-preview.png", full: "./gallery/illustrator/9jgDa9q.png",
      },
      {
        width: 29,
        height: 41,
        src: "./gallery/illustrator/MMLIoxq-preview.png", full: "./gallery/illustrator/MMLIoxq.png",
      },
      {
        width: 91,
        height: 93,
        src: "./gallery/illustrator/w6EirNb-preview.png", full: "./gallery/illustrator/w6EirNb.png",
      },
      {
        width: 97,
        height: 52,
        src: "./gallery/illustrator/gpoN6pc-preview.png", full: "./gallery/illustrator/gpoN6pc.png",
      },
      {
        width: 1,
        height: 1,
        src: "./gallery/illustrator/lKStuQm-preview.png", full: "./gallery/illustrator/lKStuQm.png",
      },
      {
        width: 29,
        height: 41,
        src: "./gallery/illustrator/74KTAg0-preview.png", full: "./gallery/illustrator/74KTAg0.png",
      },
      {
        src: "./gallery/illustrator/6LtLpAg-preview.png", full: "./gallery/illustrator/6LtLpAg.png",
        height: 73,
        width: 177,
      },
    ],
    rowHeight: 500,
    preview: "./gallery/illustrator/preview_RxJ46jc.png",
    description: "Works done in the course Intro to Illustrator",
    title: "Intro to Illustrator",
  },
  photoshop: {
    images: [
      {
        src: "./gallery/photoshop/gNOVRJK-preview.jpg", full: "./gallery/photoshop/gNOVRJK.jpg",
        height: 41,
        width: 58,
      },
      {
        src: "./gallery/photoshop/bwCnmPA-preview.jpg", full: "./gallery/photoshop/bwCnmPA.jpg",
        height: 41,
        width: 58,
      },
      {
        src: "./gallery/photoshop/hw-3-burn1-preview.png", full: "./gallery/photoshop/hw-3-burn1.png",
        height: 95,
        width: 83,
      },
      {
        src: "./gallery/photoshop/kyIGusE-preview.png", full: "./gallery/photoshop/kyIGusE.png",
        height: 49,
        width: 67,
      },
      {
        src: "./gallery/photoshop/hw-3-burn3-preview.png", full: "./gallery/photoshop/hw-3-burn3.png",
        height: 17,
        width: 15,
      },
      {
        src: "./gallery/photoshop/hw-3-burn8-preview.png", full: "./gallery/photoshop/hw-3-burn8.png",
        height: 2,
        width: 3,
      },
      {
        src: "./gallery/photoshop/hw-3-burn7-preview.png", full: "./gallery/photoshop/hw-3-burn7.png",
        height: 83,
        width: 146,
      },
      {
        src: "./gallery/photoshop/gm19ChR-preview.png", full: "./gallery/photoshop/gm19ChR.png",
        height: 44,
        width: 51,
      },
      {
        src: "./gallery/photoshop/A3FoGxE-preview.jpg", full: "./gallery/photoshop/A3FoGxE.jpg",
        height: 33,
        width: 100,
      },
      {
        src: "./gallery/photoshop/Nbq5oml-preview.jpg", full: "./gallery/photoshop/Nbq5oml.jpg",
        height: 13,
        width: 30,
      },
      {
        src: "./gallery/photoshop/MkoOqZP-preview.jpg", full: "./gallery/photoshop/MkoOqZP.jpg",
        height: 9,
        width: 32,
      },
      {
        src: "./gallery/photoshop/qQwNd0u-preview.jpg", full: "./gallery/photoshop/qQwNd0u.jpg",
        height: 25,
        width: 99,
      },
      {
        src: "./gallery/photoshop/dLGIWHW-preview.png", full: "./gallery/photoshop/dLGIWHW.png",
        height: 43,
        width: 155,
      },
      {
        src: "./gallery/photoshop/h7Moroj-preview.png", full: "./gallery/photoshop/h7Moroj.png",
        height: 47,
        width: 167,
      },
    ],
    rowHeight: 300,
    preview: "./gallery/photoshop/preview_5qWgids.png",
    description: "Works done in the course Intro to Photoshop",
    title: "Intro to Photoshop",
  },
  miniatures: {
    images: [
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/cQIuKDt.png",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/miniatures/bvYbrc7-preview.png", full: "./gallery/miniatures/bvYbrc7.png",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/h4pI6IH-preview.png", full: "./gallery/miniatures/h4pI6IH.png",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/FlIQJFv-preview.png", full: "./gallery/miniatures/FlIQJFv.png",
      },
      {
        width: 83,
        height: 94,
        src: "./gallery/miniatures/L3eZ0YO-preview.png", full: "./gallery/miniatures/L3eZ0YO.png",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/miniatures/SPZ8X0i-preview.png", full: "./gallery/miniatures/SPZ8X0i.png",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/tPv6x38-preview.png", full: "./gallery/miniatures/tPv6x38.png",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/gMmwwks-preview.jpg", full: "./gallery/miniatures/gMmwwks.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/HU6p2DP-preview.jpg", full: "./gallery/miniatures/HU6p2DP.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/ffxrdjA-preview.jpg", full: "./gallery/miniatures/ffxrdjA.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/WMcrbMB-preview.jpg", full: "./gallery/miniatures/WMcrbMB.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/BeOykUI-preview.jpg", full: "./gallery/miniatures/BeOykUI.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/q6MBi4o-preview.jpg", full: "./gallery/miniatures/q6MBi4o.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/ZKYPgKG-preview.jpg", full: "./gallery/miniatures/ZKYPgKG.jpg",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/miniatures/smlykM6-preview.jpg", full: "./gallery/miniatures/smlykM6.jpg",
      },
    ],
    rowHeight: 300,
    preview: "./gallery/miniatures/preview_RWnWg82.png",
    description: "D&D miniatures painted with acrylics",
    title: "Miniature Paintings",
  },
  "drawings-old": {
    images: [
      {
        width: 94,
        height: 73,
        src: "./gallery/drawings-old/LGWi5mJ-preview.png", full: "./gallery/drawings-old/LGWi5mJ.png",
      },
      {
        width: 121,
        height: 83,
        src: "./gallery/drawings-old/pMMeZco-preview.jpg", full: "./gallery/drawings-old/pMMeZco.jpg",
      },
      {
        width: 17,
        height: 25,
        src: "./gallery/drawings-old/CZIuEns-preview.png", full: "./gallery/drawings-old/CZIuEns.png",
      },
      {
        width: 90,
        height: 71,
        src: "./gallery/drawings-old/tB5afCP-preview.jpg", full: "./gallery/drawings-old/tB5afCP.jpg",
      },
      {
        width: 71,
        height: 94,
        src: "./gallery/drawings-old/7E5DJ0m-preview.png", full: "./gallery/drawings-old/7E5DJ0m.png",
      },
      {
        width: 35,
        height: 51,
        src: "./gallery/drawings-old/wYDDPom-preview.jpg", full: "./gallery/drawings-old/wYDDPom.jpg",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings-old/8q0fPAr-preview.jpg", full: "./gallery/drawings-old/8q0fPAr.jpg",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings-old/tsOTVzV-preview.jpg", full: "./gallery/drawings-old/tsOTVzV.jpg",
      },
      {
        width: 3,
        height: 4,
        src: "./gallery/drawings-old/7X4yY5W-preview.jpg", full: "./gallery/drawings-old/7X4yY5W.jpg",
      },
      {
        width: 64,
        height: 65,
        src: "./gallery/drawings-old/kyEVfTq-preview.png", full: "./gallery/drawings-old/kyEVfTq.png",
      },
      {
        width: 34,
        height: 53,
        src: "./gallery/drawings-old/PHgs6Qe-preview.png", full: "./gallery/drawings-old/PHgs6Qe.png",
      },
      {
        width: 56,
        height: 79,
        src: "./gallery/drawings-old/ySXzQwk-preview.png", full: "./gallery/drawings-old/ySXzQwk.png",
      },
      {
        width: 69,
        height: 94,
        src: "./gallery/drawings-old/X9FUQU2-preview.png", full: "./gallery/drawings-old/X9FUQU2.png",
      },
      {
        width: 62,
        height: 39,
        src: "./gallery/drawings-old/mbKPXcm-preview.png", full: "./gallery/drawings-old/mbKPXcm.png",
      },
      {
        width: 5,
        height: 7,
        src: "./gallery/drawings-old/I9pmLcu-preview.png", full: "./gallery/drawings-old/I9pmLcu.png",
      },
      {
        width: 23,
        height: 31,
        src: "./gallery/drawings-old/l4XtjHV-preview.png", full: "./gallery/drawings-old/l4XtjHV.png",
      },
      {
        width: 36,
        height: 23,
        src: "./gallery/drawings-old/bkle1XT-preview.png", full: "./gallery/drawings-old/bkle1XT.png",
      },
    ],
    rowHeight: 500,
    preview: "./gallery/drawings-old/preview_Nm00cXA.png",
    title: "Drawings done around 2010-2014",
  },
  "designs-old": {
    images: [
      {
        width: 87,
        height: 32,
        src: "./gallery/designs-old/98VnOmu-preview.png", full: "./gallery/designs-old/98VnOmu.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/tzfwN2L-preview.png", full: "./gallery/designs-old/tzfwN2L.png",
      },
      {
        width: 40,
        height: 11,
        src: "./gallery/designs-old/4I4dYTT-preview.png", full: "./gallery/designs-old/4I4dYTT.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/kBr6qNr-preview.png", full: "./gallery/designs-old/kBr6qNr.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/RmJjXcF-preview.png", full: "./gallery/designs-old/RmJjXcF.png",
      },
      {
        width: 42,
        height: 11,
        src: "./gallery/designs-old/bbHL7wg-preview.png", full: "./gallery/designs-old/bbHL7wg.png",
      },
      {
        width: 1,
        height: 1,
        src: "./gallery/designs-old/YvoLsR7-preview.png", full: "./gallery/designs-old/YvoLsR7.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/fWzvCW6-preview.png", full: "./gallery/designs-old/fWzvCW6.png",
      },
      {
        width: 25,
        height: 8,
        src: "./gallery/designs-old/4huW76T-preview.png", full: "./gallery/designs-old/4huW76T.png",
      },
      {
        width: 25,
        height: 8,
        src: "./gallery/designs-old/vHLKEq9-preview.png", full: "./gallery/designs-old/vHLKEq9.png",
      },
      {
        width: 100,
        height: 59,
        src: "./gallery/designs-old/9mNAgRe-preview.png", full: "./gallery/designs-old/9mNAgRe.png",
      },
      {
        width: 25,
        height: 8,
        src: "./gallery/designs-old/mV4OKM9-preview.png", full: "./gallery/designs-old/mV4OKM9.png",
      },
      {
        width: 13,
        height: 5,
        src: "./gallery/designs-old/ABYUx7F-preview.png", full: "./gallery/designs-old/ABYUx7F.png",
      },
      {
        width: 13,
        height: 5,
        src: "./gallery/designs-old/Q2Fk868-preview.png", full: "./gallery/designs-old/Q2Fk868.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/qLW1yOP-preview.png", full: "./gallery/designs-old/qLW1yOP.png",
      },
      {
        width: 45,
        height: 13,
        src: "./gallery/designs-old/uBVaEeT-preview.png", full: "./gallery/designs-old/uBVaEeT.png",
      },
      {
        width: 37,
        height: 11,
        src: "./gallery/designs-old/w0UzDuo-preview.png", full: "./gallery/designs-old/w0UzDuo.png",
      },
      {
        width: 18,
        height: 5,
        src: "./gallery/designs-old/U8U0Z7U-preview.png", full: "./gallery/designs-old/U8U0Z7U.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/9YxoLWm-preview.png", full: "./gallery/designs-old/9YxoLWm.png",
      },
      {
        width: 33,
        height: 25,
        src: "./gallery/designs-old/jjYHvrm-preview.png", full: "./gallery/designs-old/jjYHvrm.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/eK2GaY3-preview.png", full: "./gallery/designs-old/eK2GaY3.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/4x5MC4U-preview.png", full: "./gallery/designs-old/4x5MC4U.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/mKr0k7G-preview.png", full: "./gallery/designs-old/mKr0k7G.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/cZvbmfc-preview.png", full: "./gallery/designs-old/cZvbmfc.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/OAOFXLq-preview.png", full: "./gallery/designs-old/OAOFXLq.png",
      },
      {
        width: 7,
        height: 3,
        src: "./gallery/designs-old/ncE4SZF-preview.png", full: "./gallery/designs-old/ncE4SZF.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/r7NsUE7-preview.png", full: "./gallery/designs-old/r7NsUE7.png",
      },
      {
        width: 77,
        height: 18,
        src: "./gallery/designs-old/tAOMJC4-preview.png", full: "./gallery/designs-old/tAOMJC4.png",
      },
      {
        width: 17,
        height: 5,
        src: "./gallery/designs-old/t9zKd8R-preview.png", full: "./gallery/designs-old/t9zKd8R.png",
      },
      {
        width: 25,
        height: 6,
        src: "./gallery/designs-old/Y6eASIg-preview.png", full: "./gallery/designs-old/Y6eASIg.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/iP9p6fk-preview.png", full: "./gallery/designs-old/iP9p6fk.png",
      },
      {
        width: 25,
        height: 8,
        src: "./gallery/designs-old/cE7aJIS-preview.png", full: "./gallery/designs-old/cE7aJIS.png",
      },
      {
        width: 205,
        height: 64,
        src: "./gallery/designs-old/xnLmN1S-preview.png", full: "./gallery/designs-old/xnLmN1S.png",
      },
      {
        width: 66,
        height: 23,
        src: "./gallery/designs-old/DGR3OIj-preview.png", full: "./gallery/designs-old/DGR3OIj.png",
      },
      {
        width: 25,
        height: 8,
        src: "./gallery/designs-old/jqA4FSc-preview.png", full: "./gallery/designs-old/jqA4FSc.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/Vbhogbo-preview.png", full: "./gallery/designs-old/Vbhogbo.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/1QAuy6M-preview.png", full: "./gallery/designs-old/1QAuy6M.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/0S6U7Ga-preview.png", full: "./gallery/designs-old/0S6U7Ga.png",
      },
      {
        width: 37,
        height: 11,
        src: "./gallery/designs-old/jsphmuG-preview.png", full: "./gallery/designs-old/jsphmuG.png",
      },
      {
        width: 80,
        height: 27,
        src: "./gallery/designs-old/qpMCiBd-preview.png", full: "./gallery/designs-old/qpMCiBd.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/1qaopZK-preview.png", full: "./gallery/designs-old/1qaopZK.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/uGgtboi-preview.png", full: "./gallery/designs-old/uGgtboi.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/uSSkW2E-preview.png", full: "./gallery/designs-old/uSSkW2E.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/jZ6FxOq-preview.png", full: "./gallery/designs-old/jZ6FxOq.png",
      },
      {
        width: 32,
        height: 15,
        src: "./gallery/designs-old/2E099Dr-preview.png", full: "./gallery/designs-old/2E099Dr.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/e26M9Te-preview.png", full: "./gallery/designs-old/e26M9Te.png",
      },
      {
        width: 355,
        height: 98,
        src: "./gallery/designs-old/zJJjkpx-preview.png", full: "./gallery/designs-old/zJJjkpx.png",
      },
      {
        width: 355,
        height: 98,
        src: "./gallery/designs-old/g89YyFP-preview.png", full: "./gallery/designs-old/g89YyFP.png",
      },
      {
        width: 40,
        height: 17,
        src: "./gallery/designs-old/HwHf9G8-preview.png", full: "./gallery/designs-old/HwHf9G8.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/XIsLfHE-preview.png", full: "./gallery/designs-old/XIsLfHE.png",
      },
      {
        width: 357,
        height: 100,
        src: "./gallery/designs-old/qf9BppC-preview.png", full: "./gallery/designs-old/qf9BppC.png",
      },
      {
        width: 357,
        height: 100,
        src: "./gallery/designs-old/91tFF2w-preview.png", full: "./gallery/designs-old/91tFF2w.png",
      },
      {
        width: 7,
        height: 2,
        src: "./gallery/designs-old/Cirgnd7-preview.png", full: "./gallery/designs-old/Cirgnd7.png",
      },
      {
        width: 3,
        height: 2,
        src: "./gallery/designs-old/WV4mtiW-preview.png", full: "./gallery/designs-old/WV4mtiW.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/ryPZRkq-preview.png", full: "./gallery/designs-old/ryPZRkq.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/RzcHyZP-preview.png", full: "./gallery/designs-old/RzcHyZP.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/rCiejz2-preview.png", full: "./gallery/designs-old/rCiejz2.png",
      },
      {
        width: 39,
        height: 10,
        src: "./gallery/designs-old/3RGyLAD-preview.png", full: "./gallery/designs-old/3RGyLAD.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/htywSur-preview.png", full: "./gallery/designs-old/htywSur.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/EO3iCjY-preview.png", full: "./gallery/designs-old/EO3iCjY.png",
      },
      {
        width: 71,
        height: 20,
        src: "./gallery/designs-old/iXVOge5-preview.png", full: "./gallery/designs-old/iXVOge5.png",
      },
      {
        width: 58,
        height: 57,
        src: "./gallery/designs-old/74jB9yA-preview.png", full: "./gallery/designs-old/74jB9yA.png",
      },
      {
        width: 72,
        height: 25,
        src: "./gallery/designs-old/aID4v0Y-preview.png", full: "./gallery/designs-old/aID4v0Y.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/vGwAmyP-preview.png", full: "./gallery/designs-old/vGwAmyP.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/t6HFJKO-preview.png", full: "./gallery/designs-old/t6HFJKO.png",
      },
      {
        width: 35,
        height: 11,
        src: "./gallery/designs-old/IhodABp-preview.png", full: "./gallery/designs-old/IhodABp.png",
      },
      {
        width: 35,
        height: 11,
        src: "./gallery/designs-old/x7eXpeE-preview.png", full: "./gallery/designs-old/x7eXpeE.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/iJDvfrJ-preview.png", full: "./gallery/designs-old/iJDvfrJ.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/93bzAcw-preview.png", full: "./gallery/designs-old/93bzAcw.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/6FP4Xyo-preview.png", full: "./gallery/designs-old/6FP4Xyo.png",
      },
      {
        width: 263,
        height: 67,
        src: "./gallery/designs-old/8vM6aWZ-preview.png", full: "./gallery/designs-old/8vM6aWZ.png",
      },
      {
        width: 7,
        height: 3,
        src: "./gallery/designs-old/KTuqXgX-preview.png", full: "./gallery/designs-old/KTuqXgX.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/2MS0hhg-preview.png", full: "./gallery/designs-old/2MS0hhg.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/MdWV8W0-preview.png", full: "./gallery/designs-old/MdWV8W0.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/pY0m7B7-preview.png", full: "./gallery/designs-old/pY0m7B7.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/fTs5tCD-preview.png", full: "./gallery/designs-old/fTs5tCD.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/Yh80xEX-preview.png", full: "./gallery/designs-old/Yh80xEX.png",
      },
      {
        width: 62,
        height: 91,
        src: "./gallery/designs-old/8O3WUEC-preview.png", full: "./gallery/designs-old/8O3WUEC.png",
      },
      {
        width: 19,
        height: 5,
        src: "./gallery/designs-old/HmwioN5-preview.png", full: "./gallery/designs-old/HmwioN5.png",
      },
      {
        width: 11,
        height: 4,
        src: "./gallery/designs-old/j52RlDB-preview.png", full: "./gallery/designs-old/j52RlDB.png",
      },
      {
        width: 62,
        height: 91,
        src: "./gallery/designs-old/PheYHvS-preview.png", full: "./gallery/designs-old/PheYHvS.png",
      },
      {
        width: 62,
        height: 91,
        src: "./gallery/designs-old/VlSaAZR-preview.png", full: "./gallery/designs-old/VlSaAZR.png",
      },
      {
        width: 317,
        height: 92,
        src: "./gallery/designs-old/KvZ9sPl-preview.png", full: "./gallery/designs-old/KvZ9sPl.png",
      },
      {
        width: 39,
        height: 10,
        src: "./gallery/designs-old/egZhXoU-preview.png", full: "./gallery/designs-old/egZhXoU.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/D2qYVrj-preview.png", full: "./gallery/designs-old/D2qYVrj.png",
      },
      {
        width: 61,
        height: 38,
        src: "./gallery/designs-old/gYrhxoF-preview.png", full: "./gallery/designs-old/gYrhxoF.png",
      },
      {
        width: 41,
        height: 10,
        src: "./gallery/designs-old/Ej3hLqu-preview.png", full: "./gallery/designs-old/Ej3hLqu.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/8hHjNBP-preview.png", full: "./gallery/designs-old/8hHjNBP.png",
      },
      {
        width: 25,
        height: 8,
        src: "./gallery/designs-old/zri4DFI-preview.png", full: "./gallery/designs-old/zri4DFI.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/rLKxToH-preview.png", full: "./gallery/designs-old/rLKxToH.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/6lv4POX-preview.png", full: "./gallery/designs-old/6lv4POX.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/7Xr4er5-preview.png", full: "./gallery/designs-old/7Xr4er5.png",
      },
      {
        width: 35,
        height: 13,
        src: "./gallery/designs-old/mvf0dtT-preview.png", full: "./gallery/designs-old/mvf0dtT.png",
      },
      {
        width: 40,
        height: 11,
        src: "./gallery/designs-old/rX4QDOG-preview.png", full: "./gallery/designs-old/rX4QDOG.png",
      },
      {
        width: 35,
        height: 13,
        src: "./gallery/designs-old/DwVQ2dV-preview.png", full: "./gallery/designs-old/DwVQ2dV.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/qrGtSzv-preview.png", full: "./gallery/designs-old/qrGtSzv.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/n1D11Ss-preview.png", full: "./gallery/designs-old/n1D11Ss.png",
      },
      {
        width: 79,
        height: 23,
        src: "./gallery/designs-old/AsrErXV-preview.png", full: "./gallery/designs-old/AsrErXV.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/oq66pYK-preview.png", full: "./gallery/designs-old/oq66pYK.png",
      },
      {
        width: 190,
        height: 51,
        src: "./gallery/designs-old/HspKlTO-preview.png", full: "./gallery/designs-old/HspKlTO.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/qXzY5oz-preview.png", full: "./gallery/designs-old/qXzY5oz.png",
      },
      {
        width: 100,
        height: 37,
        src: "./gallery/designs-old/v1PsAdf-preview.png", full: "./gallery/designs-old/v1PsAdf.png",
      },
      {
        width: 10,
        height: 3,
        src: "./gallery/designs-old/VKvoC1w-preview.png", full: "./gallery/designs-old/VKvoC1w.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/Ph71tmx-preview.png", full: "./gallery/designs-old/Ph71tmx.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/7IZ3kOG-preview.png", full: "./gallery/designs-old/7IZ3kOG.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/4wLLzHA-preview.png", full: "./gallery/designs-old/4wLLzHA.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/SOL8CAX-preview.png", full: "./gallery/designs-old/SOL8CAX.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/618k4FZ-preview.png", full: "./gallery/designs-old/618k4FZ.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/giRHMhs-preview.png", full: "./gallery/designs-old/giRHMhs.png",
      },
      {
        width: 134,
        height: 75,
        src: "./gallery/designs-old/ZAZBvuM-preview.png", full: "./gallery/designs-old/ZAZBvuM.png",
      },
      {
        width: 40,
        height: 9,
        src: "./gallery/designs-old/f3iCBHM-preview.png", full: "./gallery/designs-old/f3iCBHM.png",
      },
      {
        width: 35,
        height: 13,
        src: "./gallery/designs-old/ppIr89e-preview.png", full: "./gallery/designs-old/ppIr89e.png",
      },
      {
        width: 25,
        height: 6,
        src: "./gallery/designs-old/y8YdFN6-preview.png", full: "./gallery/designs-old/y8YdFN6.png",
      },
      {
        width: 19,
        height: 7,
        src: "./gallery/designs-old/QeD3FDc-preview.png", full: "./gallery/designs-old/QeD3FDc.png",
      },
      {
        width: 38,
        height: 11,
        src: "./gallery/designs-old/TTA40pB-preview.png", full: "./gallery/designs-old/TTA40pB.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/kc4h45d-preview.png", full: "./gallery/designs-old/kc4h45d.png",
      },
      {
        width: 35,
        height: 13,
        src: "./gallery/designs-old/F6TP5Nl-preview.png", full: "./gallery/designs-old/F6TP5Nl.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/9eYNmdg-preview.png", full: "./gallery/designs-old/9eYNmdg.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/xZPIhVT-preview.png", full: "./gallery/designs-old/xZPIhVT.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/FZAsGdM-preview.png", full: "./gallery/designs-old/FZAsGdM.png",
      },
      {
        width: 394,
        height: 95,
        src: "./gallery/designs-old/LVUDm8i-preview.png", full: "./gallery/designs-old/LVUDm8i.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/xbIgOc8-preview.png", full: "./gallery/designs-old/xbIgOc8.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/BOQJVlO-preview.png", full: "./gallery/designs-old/BOQJVlO.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/3vRSl3M-preview.png", full: "./gallery/designs-old/3vRSl3M.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/mvLMW5f-preview.png", full: "./gallery/designs-old/mvLMW5f.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/pqYvUOi-preview.png", full: "./gallery/designs-old/pqYvUOi.png",
      },
      {
        width: 364,
        height: 95,
        src: "./gallery/designs-old/pryMyqG-preview.png", full: "./gallery/designs-old/pryMyqG.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/O9tYMTA-preview.png", full: "./gallery/designs-old/O9tYMTA.png",
      },
      {
        width: 1,
        height: 1,
        src: "./gallery/designs-old/vqnHlNy-preview.png", full: "./gallery/designs-old/vqnHlNy.png",
      },
      {
        width: 5,
        height: 1,
        src: "./gallery/designs-old/3KpAP9H-preview.png", full: "./gallery/designs-old/3KpAP9H.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/P7NpYuG-preview.png", full: "./gallery/designs-old/P7NpYuG.png",
      },
      {
        width: 160,
        height: 89,
        src: "./gallery/designs-old/TuM9881-preview.png", full: "./gallery/designs-old/TuM9881.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/9IDU5dt-preview.png", full: "./gallery/designs-old/9IDU5dt.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/8Uk5nxx-preview.png", full: "./gallery/designs-old/8Uk5nxx.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/DCfDCCX-preview.png", full: "./gallery/designs-old/DCfDCCX.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/HSjEYcD-preview.png", full: "./gallery/designs-old/HSjEYcD.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/uPfqf87-preview.png", full: "./gallery/designs-old/uPfqf87.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/Jdx15zh-preview.png", full: "./gallery/designs-old/Jdx15zh.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/09ef4je-preview.png", full: "./gallery/designs-old/09ef4je.png",
      },
      {
        width: 76,
        height: 17,
        src: "./gallery/designs-old/3yeQZLd-preview.png", full: "./gallery/designs-old/3yeQZLd.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/8vYeTYU-preview.png", full: "./gallery/designs-old/8vYeTYU.png",
      },
      {
        width: 80,
        height: 99,
        src: "./gallery/designs-old/45fpSf1-preview.png", full: "./gallery/designs-old/45fpSf1.png",
      },
      {
        width: 77,
        height: 19,
        src: "./gallery/designs-old/4UWma8H-preview.png", full: "./gallery/designs-old/4UWma8H.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/JSCFQwL-preview.png", full: "./gallery/designs-old/JSCFQwL.png",
      },
      {
        width: 5,
        height: 3,
        src: "./gallery/designs-old/pBAVNLn-preview.png", full: "./gallery/designs-old/pBAVNLn.png",
      },
      {
        width: 1,
        height: 1,
        src: "./gallery/designs-old/pSXwju6-preview.png", full: "./gallery/designs-old/pSXwju6.png",
      },
      {
        width: 40,
        height: 17,
        src: "./gallery/designs-old/hMQ53oZ-preview.png", full: "./gallery/designs-old/hMQ53oZ.png",
      },
      {
        width: 38,
        height: 11,
        src: "./gallery/designs-old/Xo8ZdZe-preview.png", full: "./gallery/designs-old/Xo8ZdZe.png",
      },
      {
        width: 73,
        height: 18,
        src: "./gallery/designs-old/QPotRFW-preview.png", full: "./gallery/designs-old/QPotRFW.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/GReeFc9-preview.png", full: "./gallery/designs-old/GReeFc9.png",
      },
      {
        width: 4,
        height: 3,
        src: "./gallery/designs-old/bQsJP8o-preview.png", full: "./gallery/designs-old/bQsJP8o.png",
      },
      {
        width: 35,
        height: 13,
        src: "./gallery/designs-old/VpnaTC8-preview.png", full: "./gallery/designs-old/VpnaTC8.png",
      },
      {
        width: 73,
        height: 30,
        src: "./gallery/designs-old/AuX7KjM-preview.png", full: "./gallery/designs-old/AuX7KjM.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/t4gxOfU-preview.png", full: "./gallery/designs-old/t4gxOfU.png",
      },
      {
        width: 77,
        height: 18,
        src: "./gallery/designs-old/WfTCUXw-preview.png", full: "./gallery/designs-old/WfTCUXw.png",
      },
      {
        width: 19,
        height: 6,
        src: "./gallery/designs-old/vJwuKGd-preview.png", full: "./gallery/designs-old/vJwuKGd.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/iGx1Zj9-preview.png", full: "./gallery/designs-old/iGx1Zj9.png",
      },
      {
        width: 5,
        height: 2,
        src: "./gallery/designs-old/Km0rO98-preview.png", full: "./gallery/designs-old/Km0rO98.png",
      },
      {
        width: 41,
        height: 12,
        src: "./gallery/designs-old/O618WOQ-preview.png", full: "./gallery/designs-old/O618WOQ.png",
      },
      {
        width: 71,
        height: 70,
        src: "./gallery/designs-old/7IJWyLw-preview.png", full: "./gallery/designs-old/7IJWyLw.png",
      },
      {
        width: 10,
        height: 3,
        src: "./gallery/designs-old/7yP9EQS-preview.png", full: "./gallery/designs-old/7yP9EQS.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/j9L0EBR-preview.png", full: "./gallery/designs-old/j9L0EBR.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/4z07Xrs-preview.png", full: "./gallery/designs-old/4z07Xrs.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/o2x85Zw-preview.png", full: "./gallery/designs-old/o2x85Zw.png",
      },
      {
        width: 4,
        height: 1,
        src: "./gallery/designs-old/DzmCPtw-preview.png", full: "./gallery/designs-old/DzmCPtw.png",
      },
      {
        width: 40,
        height: 11,
        src: "./gallery/designs-old/1ifHDf4-preview.png", full: "./gallery/designs-old/1ifHDf4.png",
      },
    ],
    rowHeight: 100,
    preview: "./gallery/designs-old/preview_LMpIjiH.png",
    description: 'Old style designs ("signatures") done around 2008-2010',
    title: "Old Designs",
  },
  corvus: {
    images: [
      {
        src: "./gallery/corvus/VRAOgxE.mp4",
        height: 720,
        width: 360,
      },
      {
        src: "./gallery/corvus/vPQI8R4.png",
      },
      {
        src: "./gallery/corvus/preview_g6NEi8B.jpg",
      },
    ],
    preview: "./gallery/corvus/preview_3LTcWRD.png",
    links: ["http://corvus-analysis.reallyliri.com/"],
    title: "Corvus Corpus Project",
    maxVw: 60,
  },
  horrorun: {
    images: [
      {
        src: "./gallery/horrorun/7KIMpQM.png",
        height: 41,
        width: 11,
      },
    ],
    preview: "./gallery/horrorun/preview_J4swtzk.png",
    links: ["https://horrorrun.reallyliri.com/"],
    title: "Horrorrun Mobile App",
    maxVw: 60,
  },
  junana: {
    images: [
      {
        src: "./gallery/junana/OpBbE0O.png",
        height: 32,
        width: 9,
      },
    ],
    preview: "./gallery/junana/preview_k4dMeRR.png",
    links: ["https://junana.reallyliri.com/"],
    title: "JunanaOni Mobile App",
    maxVw: 60,
  },
  complicube: {
    images: [
      {
        src: "./gallery/complicube/Ls3scsq.png",
        height: 97,
        width: 42,
      },
      {
        src: "./gallery/complicube/CStFFOr.png",
        height: 32,
        width: 45,
      },
      {
        src: "./gallery/complicube/0uXZeXZ.png",
        height: 32,
        width: 45,
      },
    ],
    preview: "./gallery/complicube/preview_kcRiiCj.png",
    title: "Complicube Website",
    maxVw: 60,
  },
  uiux: {
    images: [
      {
        src: "./gallery/uiux/fGiNnf7.png",
        height: 2,
        width: 1,
      },
      {
        src: "./gallery/uiux/xmNzuSa.png",
        height: 2,
        width: 1,
      },
      {
        src: "./gallery/uiux/GvJkIOI.png",
        height: 100,
        width: 53,
      },
    ],
    preview: "./gallery/uiux/preview_RukJTCC.png",
    title: "Other Web/Mobile Designs",
  },
};
